export class HourlyBonusItemData {
    public readonly hourlyBonusSection: number;
    public readonly id: string;
    public readonly type: string;
    public readonly freeDiceRollsReward: number;

    public constructor(index: number, id: string, type: string, freeDiceRollsReward: number) {
        this.hourlyBonusSection = index;
        this.id = id;
        this.type = type;
        this.freeDiceRollsReward = freeDiceRollsReward;
    }
}
